export const hasAlphaNumericError = (messages) =>
  messages.includes('validation.error.alpha_numeric')

export const generateErrorKeys = (errors, formatMessage) => {
  return Object.entries(errors).reduce((acc, [field, messages]) => {
    if (hasAlphaNumericError(messages)) {
      const msg = formatMessage({
        id: `${field}.validation.error.alpha_numeric`,
      })
      acc.push(msg)
    } else {
      acc.push(messages[0])
    }
    return acc
  }, [])
}
